import { generateBaseQueryKeysList } from '@/queries/utils';

export const CUSTOMER_KEYS = {
  main: 'customers',
};

export const customerQueryKeys = generateBaseQueryKeysList(CUSTOMER_KEYS.main);
